import { createSlice } from '@reduxjs/toolkit';

const signSlice = createSlice({
  name: 'sign',
  initialState: {
    signs: [],
  },
  reducers: {
    setSigns: (state, action) => {
      state.signs = action.payload;
    },
  },
});

export const { setSigns } = signSlice.actions;

export default signSlice.reducer;
